/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerOnboardRequest
 */
export interface PartnerOnboardRequest {
    /**
     * User's email.
     * @type {string}
     * @memberof PartnerOnboardRequest
     */
    email: string;
    /**
     * Personal names of a user. Usually it is a first name
     * @type {string}
     * @memberof PartnerOnboardRequest
     */
    firstName: string;
    /**
     * Family names of a user. Usually it is a last name
     * @type {string}
     * @memberof PartnerOnboardRequest
     */
    lastName: string;
    /**
     * Name of user's organization. Blank if user joins the organization.
     * @type {string}
     * @memberof PartnerOnboardRequest
     */
    companyName?: string;
    /**
     * User can use external or internal wallet. Or user can be demo user and theirs wallet can be created by demo-tools
     * @type {string}
     * @memberof PartnerOnboardRequest
     */
    realm?: string;
    /**
     * URL of keria agent responsible for user's wallet
     * @type {string}
     * @memberof PartnerOnboardRequest
     */
    keriaAgentUrl?: string;
}

/**
 * Check if a given object implements the PartnerOnboardRequest interface.
 */
export function instanceOfPartnerOnboardRequest(value: object): boolean {
    if (!('email' in value)) return false;
    if (!('firstName' in value)) return false;
    if (!('lastName' in value)) return false;
    return true;
}

export function PartnerOnboardRequestFromJSON(json: any): PartnerOnboardRequest {
    return PartnerOnboardRequestFromJSONTyped(json, false);
}

export function PartnerOnboardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerOnboardRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'realm': json['realm'] == null ? undefined : json['realm'],
        'keriaAgentUrl': json['keriaAgentUrl'] == null ? undefined : json['keriaAgentUrl'],
    };
}

export function PartnerOnboardRequestToJSON(value?: PartnerOnboardRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'companyName': value['companyName'],
        'realm': value['realm'],
        'keriaAgentUrl': value['keriaAgentUrl'],
    };
}

